import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import NotFoundComponent from "@/views/NotFoundComponent.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "/blocs/kpis/" : "/",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    { path: "*", component: NotFoundComponent },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
